import React, { useState } from 'react'
import SettingsIcon from '@mui/icons-material/Settings'
import MenuIcon from '@mui/icons-material/Menu'
import { Box, IconButton } from '@mui/material'
import { HeaderTitle, NavContainer, NavToolbar, StyledDrawer, Title1, Title2 } from '../StyledComponent'
import MenuLinks from './MenuLinks'
import TopBar from './TopBar'
// import TopBar from './TopBar'

const drawerWidth = 240

function MobileHeader({ window }) {
    const [navMenuOpen, setNavMenuOpen] = useState(false)
    const [settingsMenuOpen, setSettingsMenuOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const container = window !== undefined ? () => window().document.body : undefined
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const handleDrawerToggle = () => {
        setNavMenuOpen((prevState) => !prevState)
    }
    const handleSettingsToggle = () => {
        setSettingsMenuOpen((prevState) => !prevState)
    }

    return (
        <NavContainer style={{backgroundColor: '#1F4A7C'}}>
            <NavToolbar>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                >
                    <MenuIcon />
                </IconButton>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" style={{ maxHeight: 40 }} />
                    <HeaderTitle sx={{ display: { sm: 'block', xs: 'none' } }}>
                        <Title1 variant="h6">Government of Uttar Pradesh</Title1>
                        <Title2 variant="h5">Department of Town and Country Planning</Title2>
                    </HeaderTitle>
                </Box>

                <IconButton
                    color="inherit"
                    aria-label="open settings"
                    edge="end"
                    onClick={handleSettingsToggle}
                >
                    <SettingsIcon />
                </IconButton>

                <StyledDrawer
                    open={navMenuOpen}
                    variant="temporary"
                    container={container}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        '& .MuiDrawer-paper': { width: drawerWidth },
                    }}
                >
                    <MenuLinks
                        open={open}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        handleClick={handleClick}
                    />
                </StyledDrawer>

                <StyledDrawer
                    anchor="right"
                    variant="temporary"
                    container={container}
                    open={settingsMenuOpen}
                    onClose={handleSettingsToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        '& .MuiDrawer-paper': { width: drawerWidth },
                    }}
                >
                    <TopBar />
                </StyledDrawer>
            </NavToolbar>
        </NavContainer>
    )
}

export default MobileHeader